import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

/**
 * Toasts for the new campaign flow — the web twin of the app's
 * Toast.show({ type, text1, text2 }). Uses the site's own ToastContainer
 * (App.tsx), with a title and an optional second line.
 */
const OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  theme: 'light',
};

const content = (title: string, body?: string) =>
  body ? (
    <div>
      <div style={{ fontWeight: 700 }}>{title}</div>
      <div style={{ fontSize: 13, opacity: 0.85, marginTop: 2 }}>{body}</div>
    </div>
  ) : (
    <div style={{ fontWeight: 600 }}>{title}</div>
  );

export const notify = {
  success: (title: string, body?: string, autoClose?: number) => toast.success(content(title, body), { ...OPTIONS, ...(autoClose ? { autoClose } : {}) }),
  error: (title: string, body?: string) => toast.error(content(title, body), { ...OPTIONS, autoClose: 6000 }),
  info: (title: string, body?: string) => toast.info(content(title, body), OPTIONS),
};
